import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="error-scroller"
export default class extends Controller {
    connect() {
        // Auto-scroll on connect (when form re-renders with errors)
        this.scroll()
    }

    scroll() {
        // Smooth scroll to error summary banner
        this.element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
        })
    }
}
